import * as React from 'react';

import { AssertionDescriptorUsageTypesEnum, EntityTypes } from '../../utilities/Constants';

import { IEntityAssertionModel } from '../../interfaces/IAssertionDescriptor';
import { IValidation } from '../../interfaces/IError';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import { useZoneGetAssertionDescriptors } from '../../shared/react-query-hooks/useZoneGetAssertionDescriptors';

export interface IExpertNarrativeModalProps {
    entityAssertion: IEntityAssertionModel;
    onCancelClick: () => void;
    onSubmitClick: (entityAssertion: IEntityAssertionModel) => void;
    validation?: IValidation;
}

export function ExpertNarrativeModal(props: IExpertNarrativeModalProps) {
    const assertionDescriptorsLookup = useZoneGetAssertionDescriptors(
        AssertionDescriptorUsageTypesEnum.Expert
    );

    const [value, setValue] = useState<string>(props.entityAssertion.textValue ?? '');

    const handleNarrativeFieldTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setValue(e.target.value);
    };

    const handleSubmitClick = () => {
        if (props.entityAssertion) {
            const newEntityAssertion = { ...props.entityAssertion, textValue: value };
            props.onSubmitClick(newEntityAssertion);
        }
    };

    const handleClearClick = () => {
        setValue('');
    };

    const maxLength =
        props.entityAssertion.entityType?.id === EntityTypes.OperatingMechanism ? 300 : -1;

    const rowCount =
        props.entityAssertion.entityType?.id === EntityTypes.OperatingMechanism ? 4 : 15;

    const foundAD = assertionDescriptorsLookup.data?.find(
        (ad) => ad.guid === props.entityAssertion.assertionDescriptorGuid
    );

    if (!foundAD) {
        return null;
    }

    return (
        <Modal centered show={true} backdrop>
            <Modal.Header>
                <Modal.Title>{foundAD?.displayName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <span className="text-danger">{props.validation?.model}</span>
                </div>
                <div>
                    <textarea
                        className="form-control"
                        value={value}
                        name={foundAD?.guid}
                        rows={rowCount}
                        maxLength={maxLength}
                        onChange={handleNarrativeFieldTextChange}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-default" onClick={handleClearClick}>
                    Clear
                </button>
                <button className="btn btn-default" onClick={props.onCancelClick}>
                    Cancel
                </button>
                <button className="btn btn-black" onClick={handleSubmitClick}>
                    OK
                </button>
            </Modal.Footer>
        </Modal>
    );
}
